/* eslint-disable */
import axios from 'axios';
import { rootAPI } from '../../config/api/index';

export const FETCH_PRODUCT_DATA_REQUEST = 'FETCH_PRODUCT_DATA_REQUEST';
export const FETCH_PRODUCT_DATA_SUCCESS = 'FETCH_PRODUCT_DATA_SUCCESS';
export const FETCH_PRODUCT_DATA_FAILURE = 'FETCH_PRODUCT_DATA_FAILURE';
export const FETCH_PRODUCT_DETAILS_DATA_REQUEST = 'FETCH_PRODUCT_DETAILS_DATA_REQUEST';
export const FETCH_PRODUCT_DETAILS_DATA_SUCCESS = 'FETCH_PRODUCT_DETAILS_DATA_SUCCESS';
export const FETCH_PRODUCT_DETAILS_DATA_FAILURE = 'FETCH_PRODUCT_DETAILS_DATA_FAILURE';

export const fetchProductDataRequest = () => ({
  type: FETCH_PRODUCT_DATA_REQUEST,
});
export const fetchProductDetailsDataRequest = () => ({
  type: FETCH_PRODUCT_DATA_REQUEST,
});

export const fetchProductDataSuccess = (data) => ({
  type: FETCH_PRODUCT_DATA_SUCCESS,
  payload: data,
});
export const fetchProductDetailsDataSuccess = (data) => ({
  type: FETCH_PRODUCT_DETAILS_DATA_SUCCESS,
  payload: data,
});

export const fetchProductDataFailure = (error) => ({
  type: FETCH_PRODUCT_DATA_FAILURE,
  payload: error,
});
export const fetchProductDetialsDataFailure = (error) => ({
  type: FETCH_PRODUCT_DATA_FAILURE,
  payload: error,
});

export const fetchProductDetails = (appId, id) => {
  return async (dispatch) => {
    dispatch(fetchProductDetailsDataRequest());
    try {
      const response = await axios.get(`${rootAPI}/api/product/${appId}/${id}`);
      dispatch(fetchProductDetailsDataSuccess(response.data.data));
    } catch (err) {
      console.error('Error:', err);
      dispatch(fetchProductDetialsDataFailure(err));
    }
  };
};
